const dedicatedDietList = {
  getlist: 'specialdiet/getlist',
  add: 'specialdiet/add',
  update: 'specialdiet/update',
  remove: 'specialdiet/remove',
  get: 'specialdiet/get',
  getall: 'specialdiet/getall',
  sendSmsToBuy: 'user/special-diet-pay-sms',
  whatsApp: 'user/special-diet-pay-whatsapp',
}
export default dedicatedDietList
